module.exports = __webpack_public_path__ + "static/media/favicon.4859e39a.ico";


//////////////////
// WEBPACK FOOTER
// ./public/favicon.ico
// module id = 1527
// module chunks = 1